import React from 'react';
import Box from '@mui/material/Box';
import CEO_Image from './../../../assets/images/ceo.png'
import CBO_Image from './../../../assets/images/cbo.png'
import Grid from '@mui/material/Grid';

export default function AboutUs() {
	return (
        <Grid container>
            <Grid item xs={12} sm={1} md={1} lg={2}></Grid>
            <Grid item xs={12} sm={11} md={11} lg={10}>
                <Box display="flex" sx={{ flexDirection: { xs: 'column' }}} p={4}>
                    <Box component="p" flex={1} p={2} textAlign="center">
                        <Box component="p">
                            <a href="/">ePridim</a> is a online retailing future company will be founded in mid 2022. its main headquarter is in ghazipur, uttar pradesh, india.<br/>
                            ePridim provides searching and buying the products and also allowing to become a member of product selling by creating 
                            a seller account on ePridim.
                        </Box>
                        <Box component="h3" mt={4}>
                            "I never did a day's work in my life. it was all fun."
                        </Box>
                        <Box component="h5" textAlign="center" mb={4}>
                            ~Thomas A. Edison
                        </Box>
                    </Box>
                    <Box display="flex" flexDirection="column" justifyContent="center">
                        <Box display="flex" justifyContent="center">
                            <img src={CEO_Image} style={{ width: '240px', height: '320px'}} alt="ceo and founder" />
                        </Box>
                        <Box component="h5" textAlign="center">Ramniwas Gupta</Box>
                        <Box component="h6" textAlign="center">(CEO and Founder)</Box>
                    </Box>
                    <Box display="flex" flexDirection="column" justifyContent="center">
                        <Box display="flex" justifyContent="center">
                            <img src={CBO_Image} style={{ width: '240px', height: '320px'}} alt="cbo and co-founder" />
                        </Box>
                        <Box component="h5" textAlign="center">Vinay Singh</Box>
                        <Box component="h6" textAlign="center">(CBO and Co-Founder)</Box>
                    </Box>
                </Box>
            </Grid>
        </Grid>
	);
}
